<header class="col-12 header-page">
  <h1 class="header__page__content__title">
    Minhas Liberações
  </h1>
</header>
<ng-template #showLoading>
  <spinner [show]="true"></spinner>
</ng-template>
<ng-template #naoPossuiLiberacoes>
  <p class="col-12 aviso-sem-resultado">
    Não localizamos liberações!
  </p>
</ng-template>
<main class="main__content col-xl-12 px-2">
  <form class="col-xl-12 col-lg-12 col-md-12 col-sm-12 main__page__content__form" [formGroup]="formGroup"
    (ngSubmit)="consultar()">
    <section class="content-form">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2 px-1">
          <label class="content__form__title__label">Selecione quem deseja consultar</label>
          <ng-select bindLabel="name" bindValue="id" placeholder="Selecione um Titular" [searchable]="false" [clearable]="false"
            [items]="beneficiaries" formControlName="personCpf">
          </ng-select>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2 px-1">
          <label class="content__form__title__label">Situação</label>
          <ng-select type="text" bindLabel="description" bindValue="id" [items]="serviceStatus" [searchable]="false"
            placeholder="Selecione um status" [clearable]="true" formControlName="serviceStatusId"
            (search)="customSearchFn($event)">
          </ng-select>
        </div>
      </div>
      <div class="content__calendarios row">
        <div class="col-xs-6 col-xl-6 col-md-6 col-sm-12 mb-2 px-1">
          <label class="label-form">Data inicio</label>
          <input type="date" class="form-control input-form" formControlName="initialDate" placeholder="DD-MM-YYYY">
          <small class="form-text text-muted danger ng-star-inserted"
            *ngIf="formGroup.get('initialDate')?.touched && formGroup.get('initialDate')?.invalid">
            O campo Data inicio está inválido!
          </small>
        </div>
        <div class="col-xs-6 col-xl-6 col-md-6 col-sm-12 mb-2 px-1">
          <label class="label-form">Data fim</label>
          <input type="date" class="form-control input-form" formControlName="finalDate" placeholder="DD-MM-YYYY">
          <small class="form-text text-muted danger ng-star-inserted"
            *ngIf="formGroup.get('finalDate')?.touched && formGroup.get('finalDate')?.invalid">
            O campo Data de Nascimento está inválido!
          </small>
        </div>
      </div>
    </section>
    <button class="btn button-primary col-xl-2 col-lg-3 col-md-4 col-sm-12 mr-xl-1 mr-lg-1" type="submit"
      [disabled]="this.loading">
      <div class="d-flex" *ngIf="loading; else showSpan">
        <span class="spinner">
        </span>
        <span> Consultando</span>
      </div>
      <ng-template #showSpan>
        <span>Consultar</span>
      </ng-template>
    </button>
  </form>
  <section class="content__resultado mt-4" *ngIf="!loading; else showLoading">
    <main class="content__resultado__main" *ngIf="beneficiary?.requests?.items.length > 0; else naoPossuiLiberacoes">
      <header class="content__header">
        <h4 class="content__resultado__grid__header__title">Histórico de Liberações</h4>
        <filtro-dados [pageItens]="5" [totalItens]="beneficiary.requests.totalFiltered"
          *ngIf="beneficiary?.requests?.items.length > 0" (changeQuantidade)="onChangeQuantidadeItens($event)">
        </filtro-dados>
      </header>
      <section class="content__header__table">
        <div class="col-xl-6 col-lg-6 col-md-6">Prestador</div>
        <div class="col-xl-3 col-lg-3 col-md-3">Data da solicitação</div>
        <div class="col-xl-2 col-lg-2 col-md-2">Situação</div>
        <div class="col-xl-1 col-lg-1 col-md-1">Ações</div>
      </section>
      <section class="content__main__table">
        <div class="table__card" *ngFor="let item of beneficiary.requests.items">
          <!-- <div class="col-xl-6 display-sm-none">{{item.provider | slice: 0:30}}...</div> -->
          <div class="col-xl-6 col-lg-6 col-md-6">{{item.provider}}...</div>
          <div class="col-xl-3 col-lg-3 col-md-3">{{item.requestDate | date: 'dd/MM/yyyy'}}</div>
          <div class="col-xl-2 col-lg-2 col-md-2">
            <status [status]="item.status"></status>
          </div>
          <div class="col-xl-1 col-lg-1 col-md-1">
            <a class="fa-icon" (click)="visualizar(item)">
              <fa-icon [icon]="faEye"></fa-icon>
            </a>
          </div>
        </div>
      </section>
    </main>
    <footer>
      <paginacao [currentPage]="1" [collectionSize]="beneficiary.requests.totalFiltered"
        [pageSize]="myRequestsFilter.itemsPerPage" (changeNumber)="onChangePagination($event)"
        *ngIf="beneficiary.requests">
      </paginacao>
    </footer>
  </section>
</main>